import React, { forwardRef } from 'react'
import Card from '../components/Card'
import "./styles.css"

const CardsWrapper = forwardRef((props, ref) => {
    const data = [
        {
            heading: "Commitment to Success",
            content: "We are committed to helping students achieve academic and professional success. Our team is constantly working to improve internship opportunities and create educational content that meets the needs of today's students.",
            image: "commitment"
        },
        {
            heading: "Accessibility",
            content: "We believe that education should be accessible to everyone. That's why we offer our services free of charge, ensuring that students from all backgrounds have the opportunity to learn and develop.",
            image: "accessibility"
        },
        {
            heading: "Community Service",
            content: "Joining Intern Crafters means being part of a supportive community of like-minded individuals committed to learning and personal growth. Connect with classmates, mentors, and industry experts to expand your network and gain insight.",
            image: "community"
        }
    ]
    return (
        <section ref={ref} className='cards-wrapper'>
            {data.map(item => {
                return (
                    <Card heading={item.heading} content={item.content} img={item.image} />
                )
            })}
        </section >
    )
})

export default CardsWrapper
